'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { motion, useReducedMotion } from 'framer-motion';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { fadeUp, stagger, easeOut } from '@/lib/animations';
import { Container, GridBg, PrimaryButton, SecondaryButton } from './shared';
import { HeroProductPreview } from './HeroProductPreview';
export function Hero() {
  const $ = _c(56);
  const c = useCadrinoCopy();
  const pages = useWebsitePagesCopy();
  const reduced = useReducedMotion();
  let t0;
  if ($[0] !== pages.nav.product) {
    t0 = {
      href: "/product",
      label: pages.nav.product
    };
    $[0] = pages.nav.product;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pages.nav.partners) {
    t1 = {
      href: "/partners",
      label: pages.nav.partners
    };
    $[2] = pages.nav.partners;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pages.nav.security) {
    t2 = {
      href: "/security",
      label: pages.nav.security
    };
    $[4] = pages.nav.security;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== pages.nav.integrations) {
    t3 = {
      href: "/integrations",
      label: pages.nav.integrations
    };
    $[6] = pages.nav.integrations;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = [t0, t1, t2, t3];
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const pageLinks = t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <GridBg />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = reduced ? false : "hidden";
  const t7 = reduced ? undefined : "visible";
  let t8;
  if ($[14] !== c.hero.badge) {
    t8 = <motion.p variants={fadeUp} className="mb-4 inline-flex rounded-lg border border-white/[0.08] bg-white/[0.04] px-3 py-1 text-xs text-cadrino-muted">{c.hero.badge}</motion.p>;
    $[14] = c.hero.badge;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== c.hero.titleAccent) {
    t9 = <span className="block text-cadrino-primary">{c.hero.titleAccent}</span>;
    $[16] = c.hero.titleAccent;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== c.hero.title || $[19] !== t9) {
    t10 = <motion.h1 variants={fadeUp} className="text-[clamp(2.25rem,5vw,3.75rem)] font-semibold leading-[1.08] tracking-[-0.02em] text-slate-50">{c.hero.title}{t9}</motion.h1>;
    $[18] = c.hero.title;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== c.hero.subtitle) {
    t11 = <motion.p variants={fadeUp} className="mt-6 max-w-xl text-base leading-relaxed text-cadrino-muted md:text-lg">{c.hero.subtitle}</motion.p>;
    $[21] = c.hero.subtitle;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== c.hero.forWho) {
    t12 = <motion.p variants={fadeUp} className="mt-3 text-sm text-slate-400">{c.hero.forWho}</motion.p>;
    $[23] = c.hero.forWho;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== c.hero.ctaPrimary) {
    t13 = <PrimaryButton href="#contact">{c.hero.ctaPrimary}</PrimaryButton>;
    $[25] = c.hero.ctaPrimary;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== c.hero.ctaSecondary) {
    t14 = <SecondaryButton href="/how-we-work">{c.hero.ctaSecondary}</SecondaryButton>;
    $[27] = c.hero.ctaSecondary;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <motion.div variants={fadeUp} className="mt-8 flex flex-wrap gap-3">{t13}{t14}</motion.div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== c.hero.microTrust) {
    t16 = <motion.p variants={fadeUp} className="mt-6 text-xs text-cadrino-muted">{c.hero.microTrust}</motion.p>;
    $[32] = c.hero.microTrust;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== pageLinks) {
    t17 = <motion.div variants={fadeUp} className="mt-6 flex flex-wrap gap-x-4 gap-y-2 text-sm">{pageLinks.map(_temp)}</motion.div>;
    $[34] = pageLinks;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t15 || $[40] !== t16 || $[41] !== t17 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8) {
    t18 = <motion.div initial={t6} animate={t7} variants={stagger}>{t8}{t10}{t11}{t12}{t15}{t16}{t17}</motion.div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== reduced) {
    t19 = reduced ? {
      opacity: 1
    } : {
      opacity: 0,
      y: 20
    };
    $[46] = reduced;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  let t21;
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      opacity: 1,
      y: 0
    };
    t21 = {
      duration: 0.45,
      ease: easeOut,
      delay: 0.12
    };
    t22 = <HeroProductPreview />;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
  } else {
    t20 = $[48];
    t21 = $[49];
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t19) {
    t23 = <motion.div initial={t19} animate={t20} transition={t21}>{t22}</motion.div>;
    $[51] = t19;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t18 || $[54] !== t23) {
    t24 = <section className="relative overflow-hidden border-b border-white/[0.08] pb-20 pt-8 md:pb-32 md:pt-12">{t5}<Container className="relative"><div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">{t18}{t23}</div></Container></section>;
    $[53] = t18;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  return t24;
}
function _temp(link) {
  return <Link key={link.href} href={link.href} className="text-cadrino-muted transition-colors hover:text-slate-100">{link.label}</Link>;
}